export * from './register.component';